// src/services/apiService.js
import { Cookies } from "react-cookie";

const cookies = new Cookies();
const BASE_URL = `${process.env.REACT_APP_HOST_URL}`; // Replace with your backend URL
const PRODUCT_URL = `${process.env.REACT_APP_HOST_URL}/api/product`; // Replace with your backend URL
const AI_URL = "https://ai.spectsgenie.com/process-images";
const IMAGE_URL = "https://newpos.spectsgenie.com/";

const apiService = {
  // Rating API methods
  async addRating(data) {
    try {
      const response = await fetch(`${PRODUCT_URL}/addRating`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error("Failed to add rating:", error);
      throw error;
    }
  },

  async updateRating(data) {
    try {
      const response = await fetch(`${PRODUCT_URL}/updateRating`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error("Failed to update rating:", error);
      throw error;
    }
  },

  async checkExistingRating(productId, customerId) {
    try {
      const response = await fetch(`${PRODUCT_URL}/checkRating/${productId}/${customerId}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error("Failed to check existing rating:", error);
      throw error;
    }
  },

  // Existing method to fetch all products
  async fetchProducts() {
    try {
      const response = await fetch(`${PRODUCT_URL}/allProducts`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch products:", error);
      throw error;
    }
  },

  async fetchshape() {
    try {
      const response = await fetch(`${PRODUCT_URL}/allShape`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch products:", error);
      throw error;
    }
  },

   async fetchMaterials() {
    try {
      const response = await fetch(`${PRODUCT_URL}/allMaterial`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch products:", error);
      throw error;
    }
  },

  async searchProducts(searchString) {
    console.log(searchString);
    try {
      const response = await fetch(`${PRODUCT_URL}/searchProducts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ searchString }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch products:", error);
      throw error;
    }
  },

  // Fetch product by ID (existing method)
  async fetchProductById(productId, categoryId) {
    try {
      const response = await fetch(
        `${PRODUCT_URL}/getProductById/${productId}/${categoryId}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  // Create a new product (existing method)
  async createProduct(product) {
    try {
      const response = await fetch(`${PRODUCT_URL}/products`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(product),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to create product:", error);
      throw error;
    }
  },

  // Fetch products with dynamic filters, limit, and pagination
  async fetchProductsWithFilters(filters = [], limit = 10, offset = 0, table) {
    try {
      // Prepare the body for the request, including the filters, limit, and offset
      const response = await fetch(`${PRODUCT_URL}/query`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          table: table, // The table you want to query
          filters: filters, // The dynamic filters array
          limit: limit, // Limit for pagination
          offset: offset, // Offset for pagination
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch filtered products:", error);
      throw error;
    }
  },
  async fetchLensTypesId(id) {
    try {
      const response = await fetch(`${BASE_URL}/lens/getLensTypesById/${id}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async fetchLensPackagesId(id,caId) {
    try {
      const response = await fetch(`${BASE_URL}/lens/getLensPackageById/${id}/${caId}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

   async getPrescriptionFile(filePath) {
    try {
      const accessToken = cookies.get("accessToken");
      
      if (!accessToken) {
        throw new Error("No access token found. Please log in to view prescription files.");
      }

      const response = await fetch(`${BASE_URL}/cart/getPrescriptionFile`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          filePath
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Return blob and content-type for file download
      const contentType = response.headers.get("content-type");
      const fileBlob = await response.blob();
      return { data: fileBlob, contentType };
    } catch (error) {
      console.error("Failed to fetch prescription file:", error);
      throw error;
    }
  },

  async deletePrescriptionFile(filePath) {
    try {
      const accessToken = cookies.get("accessToken");
      if (!accessToken) {
        throw new Error("No access token found. Please log in to delete prescription files.");
      }
      const response = await fetch(`${BASE_URL}/cart/deletePrescriptionFile`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          filePath
        }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      // Assume server returns JSON with success status
      return await response.json();
    } catch (error) {
      console.error("Failed to delete prescription file:", error);
      throw error;
    }
  },


  async addItemToCart(product) {
    try {
      // Retrieve the access token (this could be from cookies, localStorage, or your authentication service)
      const accessToken = cookies.get("accessToken"); // assuming you're using cookies to store the token

      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/cart/addToCart`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Add the Bearer token here
        },
        body: JSON.stringify(product),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add item to cart:", error);
      throw error;
    }
  },

  async addContactLensToCart(product) {
    try {
      // Retrieve the access token (this could be from cookies, localStorage, or your authentication service)
      const accessToken = cookies.get("accessToken"); // assuming you're using cookies to store the token

      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/cart/addContactLensToCart`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Add the Bearer token here
        },
        body: JSON.stringify(product),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add item to cart:", error);
      throw error;
    }
  },

  async addTransaction(data) {
    try {
      // Retrieve the access token (this could be from cookies, localStorage, or your authentication service)
      const accessToken = cookies.get("accessToken"); // assuming you're using cookies to store the token

      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/api/phonepe/addTransaction`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Add the Bearer token here
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add item to cart:", error);
      throw error;
    }
  },

  async createOrder(data) {
    try {
      // Retrieve the access token (this could be from cookies, localStorage, or your authentication service)
      const accessToken = cookies.get("accessToken"); // assuming you're using cookies to store the token

      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/order/addNewOrder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Add the Bearer token here
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add item to order:", error);
      throw error;
    }
  },


  async fetchAddressById(id) {
    try {
      const token = cookies.get("accessToken"); // Replace "authToken" with the actual cookie key
      const response = await fetch(
        `${BASE_URL}/customer/getCustomerAddresses/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async deleteFromCart(id) {
    try {
      const response = await fetch(`${BASE_URL}/cart/deleteFromCart/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async addProductToWishlist(product) {
    try {
      // Retrieve the access token (this could be from cookies, localStorage, or your authentication service)
      const accessToken = cookies.get("accessToken"); // assuming you're using cookies to store the token

      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/wishlist/addWishlistItem`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Add the Bearer token here
        },
        body: JSON.stringify(product),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add item to wishlist:", error);
      throw error;
    }
  },

  async removeProductFromWishlist(product) {
    try {
      const token = cookies.get("accessToken");
      const response = await fetch(`${BASE_URL}/wishlist/deleteWishlistItem`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(product),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async fetchWishListStatusById(productId, customerId) {
    try {
      const url = new URL(`${PRODUCT_URL}/getWishlistStatus`);
      url.searchParams.append("productId", productId);
      url.searchParams.append("customerId", customerId);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async fetchProfileDetails(customerId) {
    try {
      const token = cookies.get("accessToken");
      const url = new URL(
        `${BASE_URL}/profile/getProfileDetails/${customerId}`
      );
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async getRef(customerId) {
    try {
      const token = cookies.get("accessToken");
      const url = new URL(
        `${BASE_URL}/profile/getRefId/${customerId}`
      );
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async editProfile(user) {
    try {
      // Retrieve the access token (this could be from cookies, localStorage, or your authentication service)
      const accessToken = cookies.get("accessToken"); // assuming you're using cookies to store the token

      if (!accessToken) {
        throw new Error("No access token found.");
      }

      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/customer/editCustomer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Add the Bearer token here
        },
        body: JSON.stringify(user),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add item to cart:", error);
      throw error;
    }
  },

  async getAIGeneratedImage(data) {
    try {
      const response = await fetch(`${AI_URL}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
      });

      if (!response.ok) {
        throw new Error("Failed to process the image");
      }

      const blob = await response.blob();
      const imageUrl = URL.createObjectURL(blob);
      return imageUrl;
    } catch (error) {
      console.error("Error generating AI image:", error);
      throw error;
    }
  },

  async fetchFile(filePath) {
    try {
      let path = `${IMAGE_URL}${filePath}`;
      const url = new URL(`${BASE_URL}/customer/getFile`);
      url.searchParams.append("url", path);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async addAddress(address) {
    try {
      // Retrieve the access token (this could be from cookies, localStorage, or your authentication service)
      const accessToken = cookies.get("accessToken"); // assuming you're using cookies to store the token

      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/address/addAddress`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Add the Bearer token here
        },
        body: JSON.stringify(address),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add address", error);
      throw error;
    }
  },

  async deleteAddress(id) {
    try {
      const token = cookies.get("accessToken"); // Replace "authToken" with the actual cookie key
      const response = await fetch(`${BASE_URL}/address/deleteAddress/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async fetchSimilarProductts(ca_id, pr_id) {
    try {
      const url = new URL(`${PRODUCT_URL}/getSimilarProducts`);
      url.searchParams.append("ca_id", ca_id);
      url.searchParams.append("pr_id", pr_id);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async fetchLAddressId(id) {
    try {
      const response = await fetch(`${BASE_URL}/address/getAddressById/${id}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async editAddress(user) {
    try {
      const response = await fetch(`${BASE_URL}/address/editAddress`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(user),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add item to cart:", error);
      throw error;
    }
  },

  async fetchWishlistProductsById(id) {
    try {
      const token = cookies.get("accessToken"); // Replace "authToken" with the actual cookie key
      const response = await fetch(`${BASE_URL}/wishlist/myWishlist/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async deleteFromWishlist(id) {
    try {
      const token = cookies.get("accessToken"); // Replace "authToken" with the actual cookie key
      const response = await fetch(`${BASE_URL}/wishlist/deleteById/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async fetchAllCoupons() {
    try {
      const response = await fetch(`${BASE_URL}/discount/allCoupons`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async fetchLocalProductData(payload) {
    try {
      const response = await fetch(`${PRODUCT_URL}/getLocalData`, {
        method: "POST", // Changed to POST
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload), // Send the payload in the request body
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch products:", error);
      throw error;
    }
  },

  async fetchLocalCartData(payload) {
    try {
      const response = await fetch(`${BASE_URL}/cart/getLocalCartData`, {
        method: "POST", // Changed to POST
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload), // Send the payload in the request body
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch products:", error);
      throw error;
    }
  },

  async addMultipleItemsToCart(product) {
    try {
      const response = await fetch(`${BASE_URL}/cart/addMultipleCartData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(product),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add item to cart:", error);
      throw error;
    }
  },

  async addMultipleItemsToWishlist(product) {
    try {
      const response = await fetch(`${BASE_URL}/wishlist/addMultipleWishlistData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(product),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add item to cart:", error);
      throw error;
    }
  },

  async fetchOrdersById(id) {



    try {
      const token = cookies.get("accessToken"); // Replace "authToken" with the actual cookie key
      const response = await fetch(`${BASE_URL}/order/getAllOrdersByCustomerID/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }   
  },

  // Check if customer has placed any orders before
  async checkCustomerOrderHistory(customerId) {
    try {
      const token = cookies.get("accessToken");
      const response = await fetch(`${BASE_URL}/order/checkOrderHistory/${customerId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to check order history:", error);
      throw error;
    }
  },

  // Update customer to Genie Gold Member
  async updateCustomerToGoldMember(customerId) {
    try {
      const token = cookies.get("accessToken");
      
      // Generate unique membership code
      const timestamp = Date.now().toString(36);
      const randomStr = Math.random().toString(36).substring(2, 8);
      const membershipCode = `GG${customerId}${timestamp}${randomStr}`.toUpperCase();
      
      const response = await fetch(`${BASE_URL}/customer/updateGoldMembership`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          customerId: customerId,
          genie_gold_member: 1,
          member_ship_code: membershipCode
        }),
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error("Failed to update gold membership:", error);
      throw error;
    }
  }, 

  async fetchCartCountById(id) {
    try {
      const response = await fetch(`${BASE_URL}/cart/cartCount/${id}`, {
        method: "GET"
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  async updateCartQuantity(payload) {
    try {
      const response = await fetch(`${BASE_URL}/cart/updateQuantity`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Ensure JSON format
        },
        body: JSON.stringify(payload), // Convert JS object to JSON string
      });
      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  },

  async addPrescription(data) {
    console.log(data)
    try {

      const response = await fetch(`${BASE_URL}/prescription/addPrescription`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add item to cart:", error);
      throw error;
    }
  },

  async fetchBrandssById(id) {
    try {
      const response = await fetch(
        `${PRODUCT_URL}/getBrands/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },

  fetchLensPackageUpgradeById: async (id) => {
    try {
      const response = await fetch(`${BASE_URL}/lens/getLensPackageUpgradeById/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // Add any authentication headers if needed
        },
      });
      
      if (!response.ok) {
        throw new Error(`Failed to fetch lens package upgrades: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error fetching lens package upgrades:', error);
      throw error;
    }
  },
  
  async addBluToCart(product) {
    try {
      // Retrieve the access token (this could be from cookies, localStorage, or your authentication service)
      const accessToken = cookies.get("accessToken"); // assuming you're using cookies to store the token

      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/cart/addBluToCart`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Add the Bearer token here
        },
        body: JSON.stringify(product),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add item to cart:", error);
      throw error;
    }
  },

  async savePrescriptionFile(fileData) {
    try {
      const accessToken = cookies.get("accessToken");

      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const formData = new FormData();
      formData.append("customer_id", fileData.user_id);
      formData.append("file", fileData.file);

      const response = await fetch(`${BASE_URL}/prescription/savePrescriptionFile`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          // Don't set Content-Type for FormData, let the browser set it automatically
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to save prescription file:", error);
      throw error;
    }
  },

  async fetchCartProductsById(id) {
    try {
      const token = cookies.get("accessToken"); // Replace "authToken" with the actual cookie key
      const response = await fetch(`${BASE_URL}/cart/myCart/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch product:", error);
      throw error;
    }
  },
  
  async fetchBundleOffers() {
    try {
      const response = await fetch(`${PRODUCT_URL}/getBundelOffer`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch bundle offers:", error);
      throw error;
    }
  },

  // Prescription API methods
  async addPrescriptionWithFile(formData) {
    try {
      const accessToken = cookies.get("accessToken");
      
      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/prescription/addPrescription`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData, // FormData for file uploads
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add prescription:", error);
      throw error;
    }
  },

  async addPrescriptionJSON(data) {
    try {
      const accessToken = cookies.get("accessToken");
      
      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/prescription/addPrescription`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add prescription:", error);
      throw error;
    }
  },

  async getPrescriptionByCustomerId(customerId) {
    try {
      const response = await fetch(`${BASE_URL}/prescription/getPrescription/${customerId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch prescriptions:", error);
      throw error;
    }
  },

  async deletePrescription(prescriptionId) {
    try {
      const accessToken = cookies.get("accessToken");
      
      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/prescription/deletePrescription/${prescriptionId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to delete prescription:", error);
      throw error;
    }
  },

  async downloadPrescription(prescriptionId) {
    try {
      const accessToken = cookies.get("accessToken");
      
      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/prescription/downloadPrescription/${prescriptionId}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.blob();
    } catch (error) {
      console.error("Failed to download prescription:", error);
      throw error;
    }
  },

  async updateCartPrescription(cartId, prescriptionData) {
    try {
      const accessToken = cookies.get("accessToken");
      
      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/cart/updatePrescription`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          cart_id: cartId,
          prescription: prescriptionData ? JSON.stringify(prescriptionData) : null
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to update cart prescription:", error);
      throw error;
    }
  },

  










  async updateReferalForNewUSer(user) {
    try {
      // Retrieve the access token (this could be from cookies, localStorage, or your authentication service)
      const accessToken = cookies.get("accessToken"); // assuming you're using cookies to store the token

      if (!accessToken) {
        throw new Error("No access token found.");
      }

      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/customer/updateReferalForNewUSer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Add the Bearer token here
        },
        body: JSON.stringify(user),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add item to cart:", error);
      throw error;
    }
  },


  async checkIdentifierExists(identifier) {
  try {
    const response = await fetch(`${BASE_URL}/profile/checkIfEmailOrMobileExists/${identifier}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    return result.exists; // returns true or false
  } catch (error) {
    console.error("Error checking identifier:", error);
    throw error;
  }
},



  async updateReferalForExistingUSer(user) {
    try {
      // Retrieve the access token (this could be from cookies, localStorage, or your authentication service)
      const accessToken = cookies.get("accessToken"); // assuming you're using cookies to store the token

      if (!accessToken) {
        throw new Error("No access token found.");
      }

      if (!accessToken) {
        throw new Error("No access token found.");
      }

      const response = await fetch(`${BASE_URL}/customer/updateReferalForExistingUSer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Add the Bearer token here
        },
        body: JSON.stringify(user),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to add item to cart:", error);
      throw error;
    }
  },


};

export default apiService;
